export const PROCEDURES_MANUAL_SHOW = "PROCEDURES_MANUAL_SHOW";
export const PROCEDURES_MANUAL_HIDE = "PROCEDURES_MANUAL_HIDE";
export const PROCEDURES_MANUAL_FETCH = "PROCEDURES_MANUAL_FETCH";
export const PROCEDURES_MANUAL_FETCH_SUCCESS =
  "PROCEDURES_MANUAL_FETCH_SUCCESS";
export const PROCEDURES_MANUAL_FETCH_ERROR = "PROCEDURES_MANUAL_FETCH_ERROR";
export const PROCEDURES_MANUAL_UPDATE = "PROCEDURES_MANUAL_UPDATE";
export const PROCEDURES_MANUAL_UPDATE_SUCCESS =
  "PROCEDURES_MANUAL_UPDATE_SUCCESS";
export const PROCEDURES_MANUAL_UPDATE_ERROR = "PROCEDURES_MANUAL_UPDATE_ERROR";
export const PROCEDURES_MANUAL_UPDATE_HEADER =
  "PROCEDURES_MANUAL_UPDATE_HEADER";
export const PROCEDURES_MANUAL_UPDATE_HEADER_SUCESS =
  "PROCEDURES_MANUAL_UPDATE_HEADER_SUCESS";
export const PROCEDURES_MANUAL_UPDATE_HEADER_ERROR =
  "PROCEDURES_MANUAL_UPDATE_HEADER_ERROR";

export const PROCEDURES_MANUAL_CREATE = "PROCEDURES_MANUAL_CREATE";
export const PROCEDURES_MANUAL_CREATE_ERROR = "PROCEDURES_MANUAL_CREATE_ERROR";
export const PROCEDURES_MANUAL_CREATE_SUCCESS =
  "PROCEDURES_MANUAL_CREATE_SUCCESS";

export const ACTIONS_ONE_TIME_DEVIATION = "ACTIONS_ONE_TIME_DEVIATION";
export const ACTIONS_ONE_TIME_DEVIATION_SUCCESS =
  "ACTIONS_ONE_TIME_DEVIATION_SUCCESS";
export const ACTIONS_ONE_TIME_DEVIATION_ERROR =
  "ACTIONS_ONE_TIME_DEVIATION_ERROR";

export const ACTIONS_SELECT_PROJECT = "ACTIONS_SELECT_PROJECT";
export const ACTIONS_SELECT_PROJECT_FUNCTION =
  "ACTIONS_SELECT_PROJECT_FUNCTION";

export const ACTION_UPDATE = "ACTION_UPDATE";
export const ACTION_UPDATE_SUCCESS = "ACTION_UPDATE_SUCCESS";
export const ACTION_UPDATE_ERROR = "ACTION_UPDATE_ERROR";

export const ACTION_UPDATE_ALL = "ACTION_UPDATE_ALL";
export const ACTION_UPDATE_ALL_SUCCESS = "ACTION_UPDATE_ALL_SUCCESS";
export const ACTION_UPDATE_ALL_ERROR = "ACTION_UPDATE_ALL_ERROR";

export const ACTION_CHANGE_COMPLIANCE = "ACTION_CHANGE_COMPLIANCE";
export const ACTION_CHANGE_COMPLIANCE_SUCCESS =
  "ACTION_CHANGE_COMPLIANCE_SUCCESS";
export const ACTION_CHANGE_COMPLIANCE_ERROR = "ACTION_CHANGE_COMPLIANCE_ERROR";

export const ACTIONS_FETCH = "ACTIONS_FETCH";
export const ACTIONS_FETCH_SUCCESS = "ACTIONS_FETCH_SUCCESS";
export const ACTIONS_FETCH_ERROR = "ACTIONS_FETCH_ERROR";

export const ACTIONS_SET_PENDING_STEP_INDEX = "ACTIONS_SET_PENDING_STEP_INDEX";

export const ACTIONS_FETCH_PROJECT_FUNCTIONS =
  "ACTIONS_FETCH_PROJECT_FUNCTIONS";
export const ACTIONS_FETCH_PROJECT_FUNCTIONS_SUCCESS =
  "ACTIONS_FETCH_PROJECT_FUNCTIONS_SUCCESS";
export const ACTIONS_FETCH_PROJECT_FUNCTIONS_ERROR =
  "ACTIONS_FETCH_PROJECT_FUNCTIONS_ERROR";

export const ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS =
  "ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS";
export const ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS_SUCCESS =
  "ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS_SUCCESS";
export const ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS_ERROR =
  "ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS_ERROR";

export const ACTIONS_SUBMIT = "ACTIONS_SUBMIT";
export const ACTIONS_SUBMIT_SUCCESS = "ACTIONS_SUBMIT_SUCCESS";
export const ACTIONS_SUBMIT_ERROR = "ACTIONS_SUBMIT_ERROR";

export const ACTIONS_SUBMIT_PENDING = "ACTIONS_SUBMIT_PENDING";
export const ACTIONS_SUBMIT_PENDING_SUCCESS = "ACTIONS_SUBMIT_PENDING_SUCCESS";
export const ACTIONS_SUBMIT_PENDING_ERROR = "ACTIONS_SUBMIT_PENDING_ERROR";

export const ACTIONS_UPDATE_APPROVED = "ACTIONS_UPDATE_APPROVED";

export const ACTIONS_UPLOAD_DEVIATION_FILES = "ACTIONS_UPLOAD_DEVIATION_FILES";
export const ACTIONS_UPLOAD_DEVIATION_SUCCESS =
  "ACTIONS_UPLOAD_DEVIATION_FILES_SUCCESS";
export const ACTIONS_UPLOAD_DEVIATION_FILES_ERROR =
  "ACTIONS_UPLOAD_DEVIATION_FILES_ERROR";

export const ACTIONS_DELETE_DEVIATION_FILE = "ACTIONS_DELETE_DEVIATION_FILE";
export const ACTIONS_DELETE_DEVIATION_FILE_SUCCESS =
  "ACTIONS_DELETE_DEVIATION_FILE_SUCCESS";
export const ACTIONS_DELETE_DEVIATION_FILE_ERROR =
  "ACTIONS_DELETE_DEVIATION_FILE_ERROR";

export const ACTIONS_SET_PENDING_SORT_PROPERTY =
  "ACTIONS_SET_PENDING_SORT_PROPERTY";
export const ACTIONS_SET_APPROVED_SORT_PROPERTY =
  "ACTIONS_SET_APPROVED_SORT_PROPERTY";

export const PROJECTS_UPDATE_IWPP_APPROVERS = "PROJECTS_UPDATE_IWPP_APPROVERS";
export const PROJECTS_UPDATE_IWPP_APPROVERS_SUCCESS =
  "PROJECTS_UPDATE_IWPP_APPROVERS_SUCCESS";
export const PROJECTS_UPDATE_IWPP_APPROVERS_ERROR =
  "PROJECTS_UPDATE_IWPP_APPROVERS_ERROR";

export const PROJECTS_DELETE_IWPP_APPROVER = "PROJECTS_DELETE_IWPP_APPROVER";
export const PROJECTS_DELETE_IWPP_APPROVER_SUCCESS =
  "PROJECTS_DELETE_IWPP_APPROVER_SUCCESS";
export const PROJECTS_DELETE_IWPP_APPROVER_ERROR =
  "PROJECTS_DELETE_IWPP_APPROVER_ERROR";

export const PROJECTS_FETCH = "PROJECTS_FETCH";
export const PROJECTS_FETCH_SUCCESS = "PROJECTS_FETCH_SUCCESS";
export const PROJECTS_FETCH_ERROR = "PROJECTS_FETCH_ERROR";

export const PROJECTS_FETCH_IWPP_APPROVERS = "PROJECTS_FETCH_IWPP_APPROVERS";
export const PROJECTS_FETCH_IWPP_APPROVERS_SUCCESS =
  "PROJECTS_FETCH_IWPP_APPROVERS_SUCCESS";
export const PROJECTS_FETCH_IWPP_APPROVERS_ERROR =
  "PROJECTS_FETCH_IWPP_APPROVERS_ERROR";

export const PROJECTS_SELECT_GBU = "PROJECTS_SELECT_GBU";
export const PROJECTS_SELECT_PROJECT = "PROJECTS_SELECT_PROJECT";
export const PROJECTS_SELECT_FUNCTION = "PROJECTS_SELECT_FUNCTION";
export const PROJECTS_EDIT_MANAGER_OF_FUNCTIONS =
  "PROJECTS_EDIT_MANAGER_OF_FUNCTIONS";

export const PROJECTS_ADD = "PROJECTS_ADD";
export const PROJECTS_ADD_SUCCESS = "PROJECTS_ADD_SUCCESS";
export const PROJECTS_ADD_ERROR = "PROJECTS_ADD_ERROR";

export const PROJECT_FUNCTION_FETCH_DETAILS = "PROJECT_FUNCTION_FETCH_DETAILS";
export const PROJECT_FUNCTION_FETCH_DETAILS_ERROR =
  "PROJECT_FUNCTION_FETCH_DETAILS_ERROR";
export const PROJECT_FUNCTION_FETCH_DETAILS_SUCCESS =
  "PROJECT_FUNCTION_FETCH_DETAILS_SUCCESS";
export const PROJECT_EDIT_FUNCTIONS = "PROJECT_EDIT_FUNCTIONS";
export const PROJECT_EDIT_FUNCTIONS_SAVE = "PROJECT_EDIT_FUNCTIONS_SAVE";
export const PROJECT_EDIT_FUNCTIONS_SAVE_SUCCESS =
  "PROJECT_EDIT_FUNCTIONS_SAVE_SUCCESS";
export const PROJECT_EDIT_FUNCTIONS_SAVE_ERROR =
  "PROJECT_EDIT_FUNCTIONS_SAVE_ERROR";
export const PROJECT_SAVE_WORKFLOW = "PROJECT_SAVE_WORKFLOW";
export const PROJECT_SAVE_WORKFLOW_SUCCESS = "PROJECT_SAVE_WORKFLOW_SUCCESS";
export const PROJECT_SAVE_WORKFLOW_ERROR = "PROJECT_SAVE_WORKFLOW_ERROR";

export const PROJECTS_UPDATE_PROJECT_WORKFLOW_APPROVERS =
  "PROJECTS_UPDATE_PROJECT_WORKFLOW_APPROVERS";
export const PROJECTS_UPDATE_PROJECT_WORKFLOW_APPROVERS_SUCCESS =
  "PROJECTS_UPDATE_PROJECT_WORKFLOW_APPROVERS_SUCCESS";
export const PROJECTS_UPDATE_PROJECT_WORKFLOW_APPROVERS_ERROR =
  "PROJECTS_UPDATE_PROJECT_WORKFLOW_APPROVERS_ERROR";

export const PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS =
  "PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS";
export const PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS_SUCCESS =
  "PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS_SUCCESS";
export const PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS_ERROR =
  "PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS_ERROR";

export const PROJECT_FUNCTION_IMPORT_PROCEDURES =
  "PROJECT_FUNCTION_IMPORT_PROCEDURES";
export const PROJECT_FUNCTION_IMPORT_PROCEDURES_SUCCESS =
  "PROJECT_FUNCTION_IMPORT_PROCEDURES_SUCCESS";
export const PROJECT_FUNCTION_IMPORT_PROCEDURES_ERROR =
  "PROJECT_FUNCTION_IMPORT_PROCEDURES_ERROR";

export const USERS_FETCH = "USERS_FETCH";
export const USERS_FETCH_SUCCESS = "USERS_FETCH_SUCCESS";
export const USERS_FETCH_ERROR = "USERS_FETCH_ERROR";
export const USER_ROLES_FETCH_SUCCESS = "USER_ROLES_FETCH_SUCCESS";
export const USER_APPROVER_ROLES_FETCH_SUCCESS = "USER_APPROVER_ROLES_FETCH_SUCCESS";

export const USERS_ADD = "USERS_ADD";
export const USERS_ADD_SUCCESS = "USERS_ADD_SUCCESS";
export const USERS_ADD_ERROR = "USERS_ADD_ERROR";

export const USERS_DELETE = "USERS_DELETE";
export const USERS_DELETE_SUCCESS = "USERS_DELETE_SUCCESS";
export const USERS_DELETE_ERROR = "USERS_DELETE_ERROR";

export const USERS_ADD_SEARCH = "USERS_ADD_SEARCH";
export const USER_FETCH_DETAILS = "USER_FETCH_DETAILS";
export const USER_FETCH_DETAILS_SUCCESS = "USER_FETCH_DETAILS_SUCCESS";
export const USER_FETCH_DETAILS_ERROR = "USER_FETCH_DETAILS_ERROR";
export const USERS_SELECT_USER = "USERS_SELECT_USER";

export const USER_SAVE_DETAILS = "USER_SAVE_DETAILS";
export const USER_SAVE_DETAILS_SUCCESS = "USER_SAVE_DETAILS_SUCCESS";
export const USER_SAVE_DETAILS_ERROR = "USER_SAVE_DETAILS_ERROR";

export const APP_CONTENT_SIZE_SET = "APP_CONTENT_SIZE_SET";
export const APP_IS_IE_SET = "APP_IS_IE_SET";
export const APP_IS_LOGGED_IN_UPDATE = "APP_IS_LOGGED_IN_UPDATE";
export const APP_SNACKBAR_MESSAGE_SET = "APP_SNACKBAR_MESSAGE_SET";

export const APP_SHOW_IMPERSONATE_MODAL = "APP_SHOW_IMPERSONATE_MODAL";
export const APP_IMPERSONATE_USER = "APP_IMPERSONATE_USER";
export const APP_IMPERSONATE_USER_SUCCESS = "APP_IMPERSONATE_USER_SUCCESS";
export const APP_IMPERSONATE_USER_ERROR = "APP_IMPERSONATE_USER_ERROR";
export const APP_FETCH_ABOUT_CURRENT_USER = "APP_FETCH_ABOUT_CURRENT_USER";
export const APP_FETCH_ABOUT_CURRENT_USER_SUCCESS =
  "APP_FETCH_ABOUT_CURRENT_USER_SUCCESS";
export const APP_FETCH_ABOUT_CURRENT_USER_ERROR =
  "APP_FETCH_ABOUT_CURRENT_USER_ERROR";

export const APP_WAKEUP = "APP_WAKEUP";
export const APP_WAKEUP_SUCCESS = "APP_WAKEUP_SUCCESS";
export const APP_WAKEUP_ERROR = "APP_WAKEUP_ERROR";

export const FUNCTIONS_FETCH = "FUNCTIONS_FETCH";
export const FUNCTIONS_FETCH_SUCCESS = "FUNCTIONS_FETCH_SUCCESS";
export const FUNCTIONS_FETCH_ERROR = "FUNCTIONS_FETCH_ERROR";
export const FUNCTIONS_SELECT_FUNCTION = "FUNCTIONS_SELECT_FUNCTION";

export const MY_RR_DOCS_FETCH = "MY_RR_DOCS_FETCH";
export const MY_RR_DOCS_FETCH_SUCCESS = "FUNCTIONS_FETCH_SUCCESS";
export const MY_RR_DOCS_FETCH_ERROR = "FUNCTIONS_FETCH_ERROR";
export const MY_RR_DOCS = "MY_RR_DOCS";

export const FUNCTION_UPDATE_CATEGORIES = "FUNCTION_UPDATE_CATEGORIES";
export const FUNCTION_UPDATE_CATEGORIES_SUCCESS =
  "FUNCTION_UPDATE_CATEGORIES_SUCCESS";
export const FUNCTION_UPDATE_CATEGORIES_ERROR =
  "FUNCTION_UPDATE_CATEGORIES_ERROR";

export const FUNCTIONS_EDIT_MANAGER_OF_FUNCTIONS =
  "FUNCTIONS_EDIT_MANAGER_OF_FUNCTIONS";
export const FUNCTIONS_UPDATE_IWPP_APPROVERS =
  "FUNCTIONS_UPDATE_IWPP_APPROVERS";
export const FUNCTIONS_UPDATE_IWPP_APPROVERS_SUCCESS =
  "FUNCTIONS_UPDATE_IWPP_APPROVERS_SUCCESS";
export const FUNCTIONS_UPDATE_IWPP_APPROVERS_ERROR =
  "FUNCTIONS_UPDATE_IWPP_APPROVERS_ERROR";
export const FUNCTIONS_DELETE_IWPP_APPROVERS = "FUNCTIONS_DELETE_IWPP_APPROVERS";
export const FUNCTIONS_DELETE_IWPP_APPROVERS_SUCCESS =
  "FUNCTIONS_DELETE_IWPP_APPROVERS_SUCCESS";
export const FUNCTIONS_DELETE_IWPP_APPROVERS_ERROR =
  "FUNCTIONS_DELETE_IWPP_APPROVERS_ERROR";
export const FUNCTIONS_FETCH_IWPP_APPROVERS = "FUNCTIONS_FETCH_IWPP_APPROVERS";
export const FUNCTIONS_FETCH_IWPP_APPROVERS_SUCCESS =
  "FUNCTIONS_FETCH_IWPP_APPROVERS_SUCCESS";
export const FUNCTIONS_FETCH_IWPP_APPROVERS_ERROR =
  "FUNCTIONS_FETCH_IWPP_APPROVERS_ERROR";

export const FUNCTION_DETAILS_FETCH = "FUNCTION_DETAILS_FETCH";
export const FUNCTION_DETAILS_FETCH_SUCCESS = "FUNCTION_DETAILS_FETCH_SUCCESS";
export const FUNCTION_DETAILS_FETCH_ERROR = "FUNCTION_DETAILS_FETCH_ERROR";
export const PROCEDURE_EDIT = "PROCEDURE_EDIT";
export const PROCEDURE_ADD = "PROCEDURE_ADD";
export const PROCEDURE_SAVE = "PROCEDURE_SAVE";
export const PROCEDURE_SAVE_SUCCESS = "PROCEDURE_SAVE_SUCCESS";
export const PROCEDURE_SAVE_ERROR = "PROCEDURE_SAVE_ERROR";

export const PROCEDURE_ADD_TO_WORKFLOW = "PROCEDURE_ADD_TO_WORKFLOW";
export const PROCEDURE_ADD_TO_WORKFLOW_SUCCESS =
  "PROCEDURE_ADD_TO_WORKFLOW_SUCCESS";
export const PROCEDURE_ADD_TO_WORKFLOW_ERROR =
  "PROCEDURE_ADD_TO_WORKFLOW_ERROR";

export const PROCEDURES_ADD_ALL_TO_WORKFLOW = "PROCEDURES_ADD_ALL_TO_WORKFLOW";
export const PROCEDURES_ADD_ALL_TO_WORKFLOW_SUCCESS =
  "PROCEDURES_ADD_ALL_TO_WORKFLOW_SUCCESS";
export const PROCEDURES_ADD_ALL_TO_WORKFLOW_ERROR =
  "PROCEDURES_ADD_ALL_TO_WORKFLOW_ERROR";

export const PROCEDURES_FETCH = "PROCEDURES_FETCH";
export const PROCEDURES_FETCH_ERROR = "PROCEDURES_FETCH_ERROR";
export const PROCEDURES_FETCH_SUCCESS = "PROCEDURES_FETCH_SUCCESS";
export const PROCEDURES_SELECT_FUNCTION_AND_PROJECT =
  "PROCEDURES_SELECT_FUNCTION_AND_PROJECT";

export const FUNCTION_UPDATE_WORKFLOW = "FUNCTION_UPDATE_WORKFLOW";
export const FUNCTION_UPDATE_WORKFLOW_SUCCESS =
  "FUNCTION_UPDATE_WORKFLOW_SUCCESS";
export const FUNCTION_UPDATE_WORKFLOW_ERROR = "FUNCTION_UPDATE_WORKFLOW_ERROR";

export const PROJECTS_FETCH_NOTIFICATIONS = "PROJECTS_FETCH_NOTIFICATIONS";
export const PROJECTS_FETCH_NOTIFICATIONS_SUCCESS =
  "PROJECTS_FETCH_NOTIFICATIONS_SUCCESS";
export const PROJECTS_FETCH_NOTIFICATIONS_ERROR =
  "PROJECTS_FETCH_NOTIFICATIONS_ERROR";

export const PROJECTS_UPDATE_NOTIFICATIONS = "PROJECTS_UPDATE_NOTIFICATIONS";
export const PROJECTS_UPDATE_NOTIFICATIONS_SUCCESS =
  "PROJECTS_UPDATE_NOTIFICATIONS_SUCCESS";
export const PROJECTS_UPDATE_NOTIFICATIONS_ERROR =
  "PROJECTS_UPDATE_NOTIFICATIONS_ERROR";

export const FUNCTION_UPDATE_NOTIFICATIONS = "FUNCTION_UPDATE_NOTIFICATIONS";
export const FUNCTION_UPDATE_NOTIFICATIONS_SUCCESS =
  "FUNCTION_UPDATE_NOTIFICATIONS_SUCCESS";
export const FUNCTION_UPDATE_NOTIFICATIONS_ERROR =
  "FUNCTION_UPDATE_NOTIFICATIONS_ERROR";

export const PROJECTS_UPDATE_PROJECT = "PROJECTS_UPDATE_PROJECT";
export const PROJECTS_UPDATE_PROJECT_SUCCESS =
  "PROJECTS_UPDATE_PROJECT_SUCCESS";
export const PROJECTS_UPDATE_PROJECT_ERROR = "PROJECTS_UPDATE_PROJECT_ERROR";

export const ACTIONS_PROCEDURE_COMMENT_SAVE = "ACTIONS_PROCEDURE_COMMENT_SAVE";
export const ACTIONS_PROCEDURE_COMMENT_SAVE_SUCCESS =
  "ACTIONS_PROCEDURE_COMMENT_SAVE_SUCCESS";
export const ACTIONS_PROCEDURE_COMMENT_SAVE_ERROR =
  "ACTIONS_PROCEDURE_COMMENT_SAVE_ERROR";

export const GBUS_FETCH = "GBUS_FETCH";
export const GBUS_FETCH_SUCCESS = "GBUS_FETCH_SUCCESS";
export const GBUS_FETCH_ERROR = "GBUS_FETCH_ERROR";

export const RESET_ALL_REDUX_STATE = "RESET_ALL_REDUX_STATE";

export const CREATE_DEVIATION = "PROCEDURE_SAVE";
